"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var WickedApiClient_1 = require("../api/WickedApiClient");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var VersionCheckService = /** @class */ (function () {
    function VersionCheckService(versionClient) {
        this.versionClient = versionClient;
        this.VersionHashKey = "Version";
        this.frequencyCheck = 30000;
        this.versionChanged = new core_1.EventEmitter();
        this.clearVersion();
        this.initVersionCheck();
        this.checkVersion();
    }
    Object.defineProperty(VersionCheckService.prototype, "CurrentHash", {
        get: function () {
            return localStorage.getItem(this.VersionHashKey) ? localStorage.getItem(this.VersionHashKey) : "";
        },
        set: function (hash) {
            localStorage.setItem(this.VersionHashKey, hash);
        },
        enumerable: true,
        configurable: true
    });
    VersionCheckService.prototype.initVersionCheck = function () {
        var _this = this;
        setInterval(function () {
            _this.checkVersion();
        }, this.frequencyCheck);
    };
    VersionCheckService.prototype.clearVersion = function () {
        localStorage.removeItem(this.VersionHashKey);
    };
    VersionCheckService.prototype.checkVersion = function () {
        var _this = this;
        this.versionClient.versionHash(new Date().getTime().toString()).subscribe(function (hash) {
            if (!_this.CurrentHash || _this.CurrentHash == "") {
                _this.CurrentHash = hash;
            }
            else {
                if (_this.hasHashChanged(_this.CurrentHash, hash)) {
                    _this.versionChanged.emit(true);
                    _this.CurrentHash = hash;
                }
            }
        });
    };
    VersionCheckService.prototype.hasHashChanged = function (currentHash, newHash) {
        if (!currentHash || !newHash || currentHash == "" || newHash == "") {
            return false;
        }
        if (!newHash) {
            return false;
        }
        return currentHash !== newHash;
    };
    VersionCheckService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionCheckService_Factory() { return new VersionCheckService(i0.ɵɵinject(i1.VersionClient)); }, token: VersionCheckService, providedIn: "root" });
    return VersionCheckService;
}());
exports.VersionCheckService = VersionCheckService;
